<app-loader *ngIf="isLoading"></app-loader>
<app-header></app-header>
<section class="breadcrumb">
    <div class="container">
        <div class="row no-gutter">
            <div class="col-md-12 breadcrumb-wrap">
                <p><a (click)="onHome()">Home</a> <img src="./../../../assets/images/rightArrow.svg"></p>
                <h2>Create a Catholic Healthcare Directive Before Your Next Medical Decision</h2>
            </div>
        </div>
    </div>
</section>
<div class="parallex">
    <div class="about-header third-container about-header-first">
        <div class="container container-mobile row">
            <div class="col-lg-6 col-md-12 about-first-detail">
                <h2>Facing an Upcoming Surgery or Major Medical Decision?</h2>
                <div class="header-title">
                    Protect Your Wishes with a Free Catholic Healthcare Directive Today.
                </div>
                <div class="info">
                    If you're dealing with a hospital stay, surgery, or a significant medical decision, it's essential
                    to have a Healthcare Directive that clearly communicates your wishes. Catholic Legacy offers a free,
                    easy-to-use tool to create a Healthcare Directive that aligns with your faith and ensures your voice
                    is heard when it matters most.
                </div>
                <button class="btn btn-primary btn-block action-btn" (click)="gotoHealthcareForm()">START YOUR FREE
                    HEALTHCARE DIRECTIVE TODAY</button>
            </div>
            <div class="col-lg-6 col-md-12 first">
                <img src="../../../assets/images/health1.webp" alt="Health">
            </div>
        </div>
    </div>
    <div class="will-legacy-section">
        <div class="container container-mobile">
            <h2>Why You Need a Healthcare Directive Now</h2>

            <div class="will-legacy-content">
                <!-- First Block -->
                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/health2.webp" alt="Ensure Your Wishes Are Respected">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Ensure Your Wishes Are Respected</h3>
                        <p>When you're facing surgery or a major medical procedure, it's crucial that your healthcare
                            team understands and respects your wishes, especially in line with your Catholic faith.
                            Hospitals often make decisions based on profit margin which may or may not be in your best
                            interest. A Healthcare Directive lets you clearly outline your preferences for medical care,
                            ensuring that your decisions are honored even if you're unable to communicate them yourself.
                            This gives back control to you and your family to prevent costly procedures you don’t want
                            or need.</p>
                    </div>
                </div>

                <!-- Second Block -->
                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/health3.webp" alt="Peace of Mind for You and Your Loved Ones">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Peace of Mind for You and Your Loved Ones</h3>
                        <p>Creating a Healthcare Directive not only provides peace of mind for you, but it also relieves
                            your loved ones from the burden of making difficult decisions during stressful times. With
                            your wishes clearly documented, they can focus on supporting you rather than worrying about
                            what you would want.</p>
                    </div>
                </div>

                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/health4.webp" alt="Protect Your Faith Values in Medical Care">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Protect Your Faith Values in Medical Care</h3>
                        <p>Catholic Legacy’s Healthcare Directive tool ensures that your medical decisions are aligned
                            with
                            your Catholic faith rather than the whim of any doctor or hospital administrator. Whether
                            it’s
                            about life-sustaining treatments, pain management, or other critical choices, you can rest
                            assured that your beliefs will guide your care.</p>
                    </div>
                </div>
            </div>

            <div class="will-cta-button">
                <button (click)="gotoHealthcareForm()" class="action-btn">START YOUR FREE HEALTHCARE DIRECTIVE
                    TODAY</button>
            </div>

            <div class="will-legacy-content">
                <!-- First Block -->
                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/health5.webp" alt="Free and Easy Healthcare Directive Creation">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Free and Easy Healthcare Directive Creation</h3>
                        <p>Our platform guides you through the process of creating a comprehensive Catholic Healthcare
                            Directive in less than 20 minutes from the comfort of your own home. It’s free to use, and
                            it’s designed to be straightforward, ensuring you can focus on your health without worrying
                            about complicated forms.</p>
                    </div>
                </div>

                <!-- Second Block -->
                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/health6.webp" alt="Aligned with Catholic Teachings">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Aligned with Catholic Teachings</h3>
                        <p>Catholic Legacy’s Healthcare Directive tool is built on Catholic ethical principles, ensuring
                            that your medical decisions are consistent with your faith. Consulting with the National
                            Catholic Bioethics Center, Catholic Legacy was built to navigate the complex issues of
                            modern medical treatments. From end-of-life care to asking for last rites, your values will
                            guide your medical care.</p>
                    </div>
                </div>

                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/health7.webp" alt="Flexibility and Accessibility">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Flexibility and Accessibility</h3>
                        <p>Your medical situation can change quickly, which is why our platform allows you to update
                            your Healthcare Directive anytime, at no cost. Whether you’re preparing for a scheduled
                            surgery or dealing with an unexpected hospital stay, you can quickly adjust your preferences
                            as needed.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="legacy-section wait-section">
        <div class="container container-mobile">
            <h2>Why You Shouldn’t Wait</h2>

            <div class="will-legacy-content">
                <!-- First Block -->
                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/health8.webp" alt="Hospitals Make Decisions Quickly">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Hospitals Make Decisions Quickly</h3>
                        <p>In a hospital setting, decisions often need to be made rapidly, and sometimes without the
                            time for thorough consultation with family members. Without a Healthcare Directive, your
                            care may not reflect your values or wishes. By creating a Directive now, you ensure that
                            your voice is heard, even if you can’t speak for yourself.
                        </p>
                    </div>
                </div>

                <!-- Second Block -->
                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/health9.webp"
                            alt="Medical Decisions Can Be Stressful for Families">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Medical Decisions Can Be Stressful for Families</h3>
                        <p>When a loved one is facing surgery or a major medical decision, families often struggle with
                            the weight of making choices on their behalf. A Catholic Healthcare Directive eases this
                            burden by clearly outlining your wishes, reducing stress, and preventing potential conflicts
                            among family members.</p>
                    </div>
                </div>

                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/health10.webp" alt="Protect Your Rights and Your Faith">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Protect Your Rights and Your Faith</h3>
                        <p>With Catholic Legacy, you can be confident that your Healthcare Directive not only protects
                            your rights but also ensures your medical care aligns with Catholic teachings. This is
                            especially important in situations where you face extreme odds of survival. A Healthcare
                            Directive can specify your desire for the Sacraments and support from a Priest, providing
                            comfort and spiritual guidance during challenging times.
                        </p>
                    </div>
                </div>
            </div>
            <div class="will-legacy-content mt-20">
                <!-- First Block -->
                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/peaceOfMind7.webp" alt="Peace of Mind">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Peace of Mind</h3>
                        <p>Knowing that your medical wishes are clearly documented can provide you and your loved ones
                            with peace of mind during a difficult time.
                        </p>
                    </div>
                </div>

                <!-- Second Block -->
                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/empowerment.webp" alt="Empowerment">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Empowerment</h3>
                        <p>By creating a Catholic Healthcare Directive, you take control of your medical care, ensuring
                            that your values and beliefs are respected.
                        </p>
                    </div>
                </div>

                <div class="will-legacy-block">
                    <div class="will-legacy-image">
                        <img src="../../../assets/images/legalProtection.webp" alt="Legal Protection">
                    </div>
                    <div class="will-legacy-text">
                        <h3>Legal Protection</h3>
                        <p>A Healthcare Directive is a legally binding document that provides clear instructions to your
                            healthcare providers and loved ones. This can help prevent disputes and ensure that your
                            wishes are honored.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="take-action about-header third-container about-header-first">
        <div class="container container-mobile row">
            <h2>Take Action Today</h2>
            <div class="col-lg-6 col-md-12 about-first-detail">
                <p>
                    Don’t wait until you’re in the hospital to start thinking about your healthcare wishes. Protect your
                    rights and ensure your medical care aligns with your Catholic faith by creating a Healthcare
                    Directive today.
                </p>
                <button (click)="gotoHealthcareForm()" class="btn btn-primary btn-block action-btn">CREATE YOUR FREE
                    HEALTHCARE DIRECTIVE NOW</button>
                <p class="italic">
                    <i>It’s quick, easy, and free—ensure your medical wishes are respected with Catholic Legacy.</i>
                </p>
            </div>
            <div class="col-lg-6 col-md-12 first">
                <img src="../../../assets/images/take-action.webp" alt="About Us">
            </div>
        </div>
    </div>
    <div class="faqs">
        <div class="container container-mobile">
            <h2>FAQs</h2>
            <div class="accordion" id="accordionExample">
                <div class="accordion-item" *ngFor="let data of faqData; index as i">
                    <h2 class="accordion-header" id="{{data._id}}">
                        <button class="accordion-button" type="button" [class.collapsed]="data.isCollapsed"
                            (click)="toggleAccordion(data)">
                            <span>{{data.question}}</span>
                        </button>
                    </h2>
                    <div [attr.id]="'collapse' + data._id + i" class="accordion-collapse collapse"
                        [class.show]="!data.isCollapsed" [attr.aria-labelledby]="data._id"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <!-- Use *ngIf to check if data.answer exists before rendering -->
                            <p *ngIf="data.answer" [innerHTML]="data.answer"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial">
        <div class="resources-wrap2 article-wrap" *ngIf="!noTestimonial && carouselReady">
            <div class="container container-mobile">
                <h2 class="mt-5">Testimonials</h2>
                <p class="headerText">Hear what our users have to say about Catholic Legacy and <a
                        style="cursor: pointer;" (click)="contactUs()">contact us</a> with your feedback.</p>
                <owl-carousel-o [options]="customOptions2" id="resourcesSlider2">
                    <ng-container *ngFor="let data of testimonailData">
                        <ng-template carouselSlide [id]="data._id">
                            <div class="sliderContainer" [ngClass]="{'oneTestimony': testimonailData.length === 1}">
                                <div class="video-wrap-testimonial">
                                    <img [src]="data.thumbnail" alt="Resources">
                                    <!-- <div class="arrow"></div> -->
                                </div>
                                <!-- <h2>{{data.title}}</h2> -->
                                <div class="description-cotainer">

                                    <blockquote style="height: fit-content;">
                                        <!-- <img src="/assets/images/icons8-quote-left-24.png" style="width:9%; height:8%;"> -->
                                        <!-- {{data.description}} -->
                                        {{ (data.clientTestimony.length > 200) ? (data.clientTestimony | slice:0:200) +
                                        '...' : data.clientTestimony }}
                                        <!-- <img src="/assets/images/icons8-quote-right-24.png" style="width:9%; height:8%;"> -->

                                    </blockquote>
                                    <div class="client-info">
                                        <div class="client-name">
                                            {{ (data.clientName.length > 20) ? (data.clientName | slice:0:20) + '...' :
                                            data.clientName }}
                                        </div>
                                        <!-- <div class="client-designation">Client Designation</div> -->
                                    </div>

                                </div>

                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
    <div class="action-container">
        <div class="container container-mobile">
            <button class="btn btn-primary btn-block action-btn" (click)="gotoHealthcareForm()">START YOUR FREE
                HEALTHCARE DIRECTIVE TODAY</button>
            <p><i>Protect your rights and ensure your medical care aligns with your Catholic faith. It’s quick, easy,
                    and free with Catholic Legacy.</i></p>
        </div>
    </div>
</div>
<app-footer></app-footer>
<button class="scroll-to-top btn-top" (click)="scrollToTop()" *ngIf="showScroll">
    <img src="../../../../assets/images/Arrow-up.svg">
</button>